<template>
  <div>
    <h1 class="display-heading">Register Your New Account</h1>
    <div v-if="accountType === -1">
      <p>Firstly, tell us which type of account you are registering for:</p>
      <div class="d-flex">
        <a
          href="javascript:void(0);"
          class="btn btn-outline-insv btn-choose-account-type"
          :class="{
            selected: accountType === 0,
          }"
          @click="accountType = 0"
        >
          <div>
            <div>
              <i class="fa fa-user"></i>
            </div>
            <p>Individual Account</p>
          </div>
        </a>
        <a
          href="javascript:void(0);"
          class="btn btn-outline-insv btn-choose-account-type"
          :class="{
            selected: accountType === 1,
          }"
          @click="accountType = 1"
        >
          <div class="">
            <div>
              <i class="fa fa-briefcase"></i>
            </div>
            <p>Corporate Account</p>
          </div>
        </a>
      </div>
    </div>
    <div v-if="accountType === 0">
      <div class="mb-3">
        <h5>Why Us?</h5>
        <ul>
          <li>
            <b>FREE</b> services for individual customers and their registered
            family members
          </li>
          <li>
            Consultation fee, medicine and laboratory costs and quality are
            controlled within our ecosystem, guided by our strategic partner,
            FPMPAM.
          </li>
          <li>
            <b>FREE</b> life-time medical record storage
            <ul>
              <li>
                i.e. uploaded medical reports, consultation and medication
                history, fully encrypted and only accessible by healthcare
                providers with prior consents given by customers.
              </li>
            </ul>
          </li>
          <li>
            Reduce risk of misdiagnosis, avoid similar laboratory test due to
            unconnected healthcare providers.
          </li>
        </ul>
      </div>
      <router-link
        :to="{ name: 'register' }"
        class="btn btn-primary btn-primary-insv"
      >
        Proceed
      </router-link>
    </div>
    <div v-else-if="accountType === 1">
      <p>Which type of Corporate Account you are looking for?</p>

      <div class="d-flex">
        <div style="margin-right: 20px;">
        <a
          href="javascript:void(0);"
          class="btn btn-outline-insv btn-choose-account-type"
          :class="{
            selected: companyAccountType === 2,
          }"
          @click="companyAccountType = 2"
        >
          <div>
            <div>
              <i class="fa fa-user-friends"></i>
            </div>
            <p>{{ getCompanyTypeByValue(2).text }}</p>
          </div>
        </a>

        <a href="https://youtu.be/IwDE3jEXaP8" target="_blank" class="mt-2 btn btn-primary btn-block btn-primary-insv">Video Guide</a>
      </div>
      <div>
        <a
          href="javascript:void(0);"
          class="btn btn-outline-insv btn-choose-account-type"
          :class="{
            selected: companyAccountType === 1,
          }"
          @click="companyAccountType = 1"
        >
          <div class="">
            <div>
              <i class="fa fa-briefcase"></i>
            </div>
            <p>{{ getCompanyTypeByValue(1).text }}</p>
          </div>
        </a>
        <a href="https://youtu.be/Mb6Fc_ubi5s" target="_blank" class="mt-2 btn btn-primary btn-block btn-primary-insv">Video Guide</a>
      </div>
    </div>

      <div class="mt-5">
        <div class="mb-5">
          <h5>Employee-Self-Paying Healthcare</h5>
          <ul>
            <li>
              <b>FREE</b> services for corporate customers' employees managing
              self-expenses
            </li>
            <li>
              <b>FREE</b> services for adding own family members as dependents,
              even their benefits are not sponsored by employer
            </li>
          </ul>
        </div>
        <div class="mb-5">
          <h5>Employer-Sponsored Healthcare</h5>
          <ul>
            <li>
              RM5 is charged by payment gateway company for topping up company's
              credit for managing corporate-sponsored employee outpatient
              benefits.
            </li>
            <li>
              Employees and dependents' medical history during employment can be
              transferrable to personal medical account seamlessly after
              employment ends, or vice versa, if future employer is also our
              registered corporate user.
            </li>
            <li>
              <b>FREE</b> services for adding own family members as dependents,
              even their benefits are not sponsored by employer
            </li>
          </ul>
        </div>
        <div>
          <h5>Both of these accounts can enjoy:</h5>
          <ul>
            <li>
              Medical certificates send to both employee and employer digitally
            </li>
            <li>
              Consultation fee, medicine and laboratory costs and quality are
              controlled within our ecosystem, guided by our strategic partner,
              FPMPAM.
            </li>
            <li>
              <b>FREE</b> life-time medical record storage
              <ul>
                <li>
                  - i.e. uploaded medical reports, consultation and medication
                  history, fully encrypted and only accessible by healthcare
                  providers with prior consents given by customers.
                </li>
              </ul>
            </li>
            <li>
              Reduce risk of misdiagnosis, avoid similar laboratory test due to
              unconnected healthcare providers.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import companyTypes, { getCompanyTypeByValue } from '@/config/companyTypes';
import Cookies from 'js-cookie';

export default {
    'name': 'RegisterLanding',
    'computed': {
        companyName () {
            return this.$store.state.operator.companyNameDisplay;
        }
    },
    'watch': {
        accountType (chosenType) {
            if (chosenType === 1) {
                this.companyAccountType = -1;
            }
        },
        companyAccountType (chosenCompanyAccountType) {
            if (chosenCompanyAccountType === 1 || chosenCompanyAccountType === 2) {
                let query = {
                    't': 4,
                    'ct': chosenCompanyAccountType
                };
                if (this.$route.query && this.$route.query.c) {
                    query.c = this.$route.query.c;
                }

                this.$router.push({
                    'name': 'register',
                    query
                });
            }
        }
    },
    data () {
        return {
            companyTypes,
            'accountType': -1,
            'companyAccountType': -1
        };
    },
    mounted () {
        if (this.$route.query) {
            if (
                this.$route.query.accountType === 1 ||
        this.$route.query.accountType === '1'
            ) {
                this.accountType = 1;
            }

            if (
                this.$route.query.r !== undefined) {
                Cookies.set('referralCode', this.$route.query.r);
            }
        }
    },
    'methods': {
        getCompanyTypeByValue
    }
};
</script>

<style>
.btn-choose-account-type {
  display: block;
  height: 150px;
  width: 200px;
  color: initial;
}

.btn-outline-insv {
  border-color: #009344;
  color: #009344;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-outline-insv:hover,
.btn-outline-insv.selected {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-choose-account-type + .btn-choose-account-type {
  margin-left: 20px;
}

.btn-choose-account-type i.fa,
.btn-choose-account-type i.fas {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.btn-choose-account-type p {
  font-size: 18px;
  margin-bottom: 0;
}
</style>
